// extracted by mini-css-extract-plugin
export default {"mode":"styles_mode__dtRRc"};